import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM6.5 3C6.5 2.72386 6.27614 2.5 6 2.5C5.72386 2.5 5.5 2.72386 5.5 3V6C5.5 6.18939 5.607 6.36252 5.77639 6.44721L7.77639 7.44721C8.02338 7.57071 8.32372 7.4706 8.44721 7.22361C8.57071 6.97662 8.4706 6.67628 8.22361 6.55279L6.5 5.69098V3Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033ZM8.66675 4.00033C8.66675 3.63214 8.36827 3.33366 8.00008 3.33366C7.63189 3.33366 7.33342 3.63214 7.33342 4.00033V8.00033C7.33342 8.25284 7.47608 8.48368 7.70194 8.59661L10.3686 9.92994C10.6979 10.0946 11.0984 9.96112 11.263 9.6318C11.4277 9.30248 11.2942 8.90203 10.9649 8.73737L8.66675 7.5883V4.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967ZM10.8333 4.99967C10.8333 4.53944 10.4602 4.16634 9.99992 4.16634C9.53968 4.16634 9.16659 4.53944 9.16659 4.99967V9.99967C9.16659 10.3153 9.34492 10.6039 9.62724 10.745L12.9606 12.4117C13.3722 12.6175 13.8728 12.4507 14.0786 12.039C14.2844 11.6274 14.1176 11.1268 13.7059 10.921L10.8333 9.48465V4.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7278_178)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM5.5 3C5.5 2.72386 5.72386 2.5 6 2.5C6.27614 2.5 6.5 2.72386 6.5 3V5.69092L8.22363 6.55273L8.26807 6.57812C8.48213 6.71378 8.56304 6.99208 8.44727 7.22363C8.33149 7.45519 8.06021 7.55764 7.82324 7.46777L7.77637 7.44727L5.77637 6.44727C5.60698 6.36257 5.5 6.18939 5.5 6V3ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7278_178">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7278_177)">
        <path d="M14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033ZM7.33342 4.00033C7.33342 3.63214 7.63189 3.33366 8.00008 3.33366C8.36827 3.33366 8.66675 3.63214 8.66675 4.00033V7.58822L10.9649 8.7373L11.0242 8.77116C11.3096 8.95203 11.4175 9.3231 11.2631 9.63184C11.1087 9.94058 10.747 10.0772 10.4311 9.95736L10.3686 9.93001L7.7019 8.59668C7.47605 8.48375 7.33342 8.25284 7.33342 8.00033V4.00033ZM15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7278_177">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7278_179)">
        <path d="M17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967ZM9.16659 4.99967C9.16659 4.53944 9.53968 4.16634 9.99992 4.16634C10.4602 4.16634 10.8333 4.53944 10.8333 4.99967V9.48454L13.706 10.9209L13.78 10.9632C14.1368 11.1893 14.2717 11.6531 14.0787 12.0391C13.8857 12.425 13.4336 12.5957 13.0387 12.446L12.9605 12.4118L9.6272 10.7451C9.34488 10.604 9.16659 10.3153 9.16659 9.99967V4.99967ZM19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7278_179">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconClock: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"clock"} {...props} />
);
